<template>
  <div id="app">
    <header>
      <div class="limit">
        <img src="@/assets/Logo.png" class="logo">
        <div class="nav">
          <div class="item" @click="$router.push('/')">Home <div class="dot"></div></div>
          <div class="item" @click="$router.push('/games')">Games <div class="dot"></div></div>
          <div class="item" @click="$router.push('/about')">Our Story <div class="dot"></div></div>
        </div>
        <div class="btn" @click="$router.push('/publishing')">Submit Your Game</div>
      </div>
    </header>
    <transition name="fade">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </transition>
    <footer>
      <img src="@/assets/Logo.png" class="logo">
      <div class="links">
        <a href="https://www.jinkeglobal.com/privacy_policy" target="_blank">Privacy Policy</a>
        <a href="https://www.jinkeglobal.com/EULA" target="_blank">Terms & Conditions</a>
      </div>
      <div class="copyright">Copyright &copy; 2010-2020 Zhejiang Jinke Culture Industry Co., LTD. All Rights Reserved.</div>
    </footer>
    <!-- <img src="@/assets/back-top.png" class="back-top" @click="backToTop" title="Back To Top" v-show="scrollPosition > 200 && $store.state.isMobile"> -->
  </div>
</template>

<script>
import device from 'current-device'
export default {
  data() {
    return {
      scrollPosition: 0
    }
  },
  created() {
    this.$store.commit('setIsMobile', device.mobile())
  },
  mounted() {
    window.onscroll = () => {
      this.scrollPosition = (document.documentElement.scrollTop || document.body.scrollTop)
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0)
    }
  },
  methods: {
    backToTop() {
      window.scrollTo(0, 0)
    }
  },
}
</script>

<style lang="stylus">
html, body
  padding 0
  margin 0
  overflow-x hidden

@media screen and (max-width: 769px)
	.fade-enter-active, .fade-leave-active 
		transition opacity .2s

	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ 
		opacity 0

.multi-select-wrapper
  margin-top 8px
  font-size 12px !important

  .required
    border-color #D2D2D2 !important

  .rounded
    border-radius 0 !important

.btn
  height 48px
  background #A700FF
  box-shadow 0px 3px 6px rgba(0, 0, 0, 0.16)
  border-radius 50px
  color #fff
  font-size 18px
  line-height 44px
  padding 0 19px
  letter-spacing 2px
  border 2px solid #A700FF
  cursor pointer
  box-sizing border-box
  transition all .3s

  &:hover
    background #000
    border 2px solid #fff
    transition all .3s

#app
  font-family 'Lato', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  overflow-x hidden
  padding-top 100px
  background #0C0A19

  @media screen and (max-width: 769px)
    padding-top 0

  header
    position fixed
    top 0
    width 100%
    height 100px
    background linear-gradient(180deg, #020205 0%, #0C0A19 100%)
    color #fff
    font-size 18px
    z-index 999

    @media screen and (max-width: 769px)
      height 220px
      position relative

    .limit
      display flex
      align-items center
      justify-content space-between
      height 100%
      max-width 1360px
      margin 0 auto

      @media screen and (max-width: 769px)
        flex-direction column
        justify-content flex-start

      .logo
        width 215px
        height 38px

        @media screen and (max-width: 769px)
          margin-top 24px

      .nav
        display flex
        align-items center
        height 100%

        @media screen and (max-width: 769px)
          height 75px

        .item
          position relative
          height 100%
          display flex
          align-items center
          font-size 18px
          font-weight lighter
          letter-spacing 2px
          margin-right 50px
          cursor pointer
          transition color .3s ease-out

          &:last-child
            margin-right 0

          &:hover
            color #A700FF

            .dot
              opacity 1
              top 70%

          .dot
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            transition all .3s ease-out
            width 6px
            height 6px
            background #A700FF
            border-radius 50%
            opacity 0


  footer 
    display flex
    flex-direction column
    align-items center
    justify-content center
    background #000
    padding 25px 0

    .links
      margin 25px 0

      a
        color #fff
        font-size 18px
        margin-right 50px
        text-decoration none

        &:hover
          color #A700FF

        &:last-child
          margin-right 0

    .copyright
      font-size 12px
      font-weight lighter
      color #fff
      text-align center

      @media screen and (max-width: 769px)
        font-size 9px

    @media screen and (max-width: 769px)
      height 120px

    .logo
      width 215px
      height 38px

      @media screen and (max-width: 769px)
        width 170px
        height 30px

  .back-top
    z-index 9
    position fixed
    right 20px
    bottom 100px
    cursor pointer
    width 40px
    height 40px
</style>
